/*
This file is located in the main branch
Last time the file was updated (UTC): [06.12.2023 15:23:25]
Permissions to update outside the main branch: [false]
*/

import { getQuestionaryItemList } from 'axios/questionaryApi';
import useApi from 'hooks/useApi';
import { QuestionaryItemInfo } from 'models/api/questionary';
import { createContext, ReactNode, useContext, useEffect, useState } from 'react';

const QuestionaryItemListContext = createContext<QuestionaryItemInfo[]>([]);

const QuestionaryItemListProvider = ({ children }: { children: ReactNode }) => {
    const [itemList, setItemList] = useState<QuestionaryItemInfo[] | null>(null);

    const api = useApi();

    useEffect(() => {
        getQuestionaryItemList(api).then((data) => {
            setItemList(data);
        });
    }, []);

    return (
        itemList && (
            <QuestionaryItemListContext.Provider value={itemList}>
                {children}
            </QuestionaryItemListContext.Provider>
        )
    );
};

const useQuestionaryItemListState = () => {
    const context = useContext(QuestionaryItemListContext);

    return context;
};

export { QuestionaryItemListProvider, useQuestionaryItemListState };
